// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"167":"def42052","271":"def42052","408":"2352ff27","498":"f6931f75","752":"8f76e9d3","928":"a73a5c3b"}[chunkId] + ".chunk.css";
};